// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.Filters.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * Filters component
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { UIPreferences } from 'config';
import connect from 'share/enhancers/Izenda.Connect';

import { GENNERAL, OBJECT_STATE } from 'logic/data/Izenda.ReportDesignerConstants';
import { FIELDS } from 'logic/data/Izenda.ReportDesignerConstants';
import droppable from 'share/components/hoc/Izenda.Droppable';
import Panel from 'share/components/controls/Izenda.Panel';
import FiltersHeader from './Izenda.FilterHeader';
import FiltersBody from './Izenda.FilterBody';
import FiltersFooter from './Izenda.FiltersFooter';
import { filter } from 'lodash/fp';

const { FITLERS_PANEL_UI: { minHeight, maxHeight } } = FIELDS;

@connect()
export default class Filters extends Component {
  static propTypes = {
    viewMode: PropTypes.bool,
    filtersData: PropTypes.object,
    reportViewerUIStore: PropTypes.object
  };

  static defaultProps = {
    reportViewerUIStore: {}
  };

  /**
   * Show information message for drop action.
   */
  dropMessage = (message: string) => {
    return this.props.confirmFn('Information', {
      description: message,
      type: 'info',
      showCloseIndicator: true
    });
  };

  filtersBodyRender = () => {
    const { store, viewMode, editMode, uiStore } = this.props;
    const filterFields = filter(field => field.state !== OBJECT_STATE.DELETE, store.reportFilters.displayFilterFields);

    const types = [GENNERAL.FIELD_ITEM, GENNERAL.FILTER_ITEM];
    const DroppableFiltersBody = viewMode ? FiltersBody : droppable(types, uiStore)(FiltersBody);

    return (
      <DroppableFiltersBody
        store={store}
        filterFields={filterFields}
        dropMessage={this.dropMessage}
        viewMode={viewMode}
        editMode={editMode}
      />
    );
  };

  render() {
    const { store, showFreeze, reportViewerUIStore, authorization, authorizationConstants, afterToggled, afterMove } = this.props;

    const header = {
      store,
      showFreeze,
      authorization,
      reportViewerUIStore,
      authorizationConstants,
      component: FiltersHeader
    };

    const filterLogicPrivilege = authorization.checkPrivileges([
      authorizationConstants.PERMISSION_KEY.ReportsFilterPropertiesFilterLogic
    ]);

    const footer = {
      store,
      context: this.context,
      component: FiltersFooter
    };

    const filterExpanded = UIPreferences.ReportFilterSectionExpanded;

    return (
      <Panel
        className="full-height"
        resizable
        header={header}
        collapsible={true}
        initState={filterExpanded}
        footer={filterLogicPrivilege && footer}
        defaultValue={minHeight}
        minValue={minHeight}
        maxValue={maxHeight}
        afterToggled={afterToggled}
        afterMove={afterMove}
      >
        {this.filtersBodyRender()}
      </Panel>
    );
  }
}



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/Filter/Izenda.Filters.js